<template>
    <div>
        <form-group label="Report" name="reportable" :required="true">
            <div class="select">
                <select v-model="reportable" id="reportable" class="input">
                    <option value="">Select a report</option>
                    <template v-for="(name, slug) in reportables">
                        <option :value="slug" v-if="typeof reports[slug] === 'undefined'">
                            {{name}}
                        </option>
                    </template>
                </select>
            </div>
        </form-group>
        <ul class="mb-4 list-reset">
            <li v-for="(report, key) in reports" class="border-b border-white">
                <a class="block bg-blue text-white hover:text-white p-2 text-sm no-underline font-heading font-bold uppercase" href="#" @click.prevent="toggleReport(key)">
                    <span class="flex items-center">
                        <span class="w-2/3">
                            {{reportables[key]}}
                        </span>
                        <span class="flex-1 flex justify-end items-center">
                            <a href="#" class="" @click.prevent="removeReport(key)">
                                <icon icon="fas fa-times" classes="text-white w-4 h-4" />
                            </a>
                            <span class="">
                                <icon :icon="active_report === key ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
                                      classes="text-white w-6 h-6" />
                            </span>
                        </span>
                    </span>
                </a>
                <span v-show="active_report === key" class="block px-2 py-4">
                    <form-group :label="reportables[key]" :name="key">
                        <textarea :name="key" class="input" :id="key" rows="10" v-model="reports[key]"></textarea>
                    </form-group>
                </span>
            </li>
        </ul>

    </div>
</template>

<script>
export default {

    props: ['dataReporting'],
    
    data() {
        return {
            active_report: '',
            reportable: '',
            reportables: {
                security: 'Security',
                safety: 'Safety',
                medical: 'Medical',
                occupational_health: 'Occupational Health and Safety',
                catering_deficiencies: 'Catering deficiencies',
                service_equipment: 'Service equipment, Service Procedures/Instructions',
                sales: 'Sales',
                entertainment: 'Entertainment/Communications',
                ground_handling: 'Ground Handling',
                service_and_product_testing: 'Service and Product Testing',
                unexpected_situations: 'Unexpected Situations',
                deviation: 'Any deviation from the Standard Operating Procedures',
                other_issues: 'Other Issues',
                crew_issues: 'Crew Issues',
            },
            reports: {}
        }
    },

    mounted() {
        this.reports = !Array.isArray(this.dataReporting) ? this.dataReporting : {};
    },

    methods: {

        toggleReport(key) {
            if(key !== this.active_report) {
                this.active_report = key
            } else {
                this.active_report = null
            }
            
        },
        
        removeReport(key) {
            this.reports[key] = undefined;
            this.reports = JSON.parse(JSON.stringify(this.reports ));
        }

    },

    watch: {
        reportable(value) {
            if(value) {
                this.reports[value] = '';
                this.reportable = '';
                this.active_report = value;
            }
        }
    }

}
</script>